<template>
  <div class="shoplistbox">
    <!-- <div class="flex2">
      <div class="flex2">
        <div class="fixed_width72">患者姓名：</div>
        <input type="text" v-model="filterCondition.name" />
      </div>
      <div class="flex2">
        <div class="fixed_width72">手机号码：</div>
        <input type="text" v-model="filterCondition.mobile" />
      </div>
      <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">处方类型：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.selectModel"
        >
          <option>西药处方</option>
        </select>
      </div>
    </div>-->
    <div class="flex2 m-b10">
      <div class="flex2">
        <div class="fixed_width72">门店名称：</div>
        <!-- <input type="text" v-model="filterCondition.shopName" @keyup.enter="getList()" /> -->
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.ShopId"
        >
          <option value="0">全部</option>
          <option
            :value="item.ShopId"
            v-for="(item, i) in childStoreList"
            :key="i"
          >
            {{ item.ShopName }}
          </option>
        </select>
      </div>
      <div class="flex2">
        <div class="fixed_width72">问诊统计时间：</div>
        <Date-picker
          type="daterange"
          split-panels
          placeholder="选择日期"
          :value="filterCondition.createDate"
          style="width: 180px; margin-right: 34px"
          :editable="false"
          @on-change="createDateChange"
        ></Date-picker>
      </div>
      <div class="inquiry_recording_search_btn pointer" @click="getList()">
        查询
      </div>
      <div class="print_btn pointer" @click="pullList()">导出</div>
    </div>

    <Table
      :columns="tableColumns"
      :data="tableData"
      border
      style="margin-bottom: 20px"
    ></Table>
    <Page
      :total="PageTotal"
      style="text-align: center"
      @on-change="pageChange"
    />
    <!--  -->
  </div>
</template>
<script>
import { GetExcelShopList, ExportExcelShopList } from "@/utils/api.js";
import { getCookie, getToken, addWaterMarker } from "@/utils/common.js";
export default {
  props: {
    childStoreList: {
      default: false,
    },
  },
  data() {
    return {
      PageTotal: 0, // 记录总条数
      page: 1,
      drugPage: 1,
      appMobilePhone: "",
      filterCondition: {
        // 筛选条件
        createDate: ["", ""],
        ShopId: "0",
      },
      tableColumns: [
        {
          title: "门店名称",
          key: "ShopName",
          align: "center",
        },
        {
          title: "门店问诊量",
          key: "InquiryCount",
          align: "center",
        },
        {
          title: "开方量",
          key: "CompleteCount",
          align: "center",
        },
        {
          title: "拒方量",
          key: "RefuseCount",
          align: "center",
        },
        {
          title: "管理员姓名",
          key: "AdminName",
          align: "center",
        },
        {
          title: "管理员手机号",
          key: "MobilePhone",
          align: "center",
        },
        // {
        //   title: "创建日期",
        //   key: "CreateTime",
        //   align: "center",
        //   render: (h, params) => {
        //     var timeArry = new Date(
        //       parseInt(params.row.CreateTime.substr(6, 13))
        //     )
        //       .toLocaleDateString()
        //       .split("/");
        //     var timeStr = timeArry[0] + "-" + timeArry[1] + "-" + timeArry[2];
        //     return h("span", timeStr);
        //   }
        // }
      ],
      tableData: [],
      pulltableData: [],
    };
  },
  methods: {
    export2Excel() {
      require.ensure([], () => {
        if (this.pulltableData.length == 0) {
          this.$Message.error("门店列表暂无数据!");
          return false;
        }
        const { export_json_to_excel } = require("../vendor/Export2Excel");
        const tHeader = [
          "门店名称",
          "门店问诊量",
          "开方量",
          "拒方量",
          "管理员姓名",
          "管理员手机号",
          "统计时间",
        ];
        const filterVal = [
          "ShopName",
          "InquiryCount",
          "CompleteCount",
          "RefuseCount",
          "AdminName",
          "MobilePhone",
          "StatisticalTime",
        ];
        const list = this.pulltableData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "列表excel");
      });
    },
    //选择日期触发条件
    createDateChange(value) {
      this.filterCondition.createDate = value;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getList() {
      if (!this.filterCondition.createDate[0]) {
        this.$Message.error("请选择时间");
        return;
      }
      var params = {
        shopId: this.filterCondition.ShopId,
        startDateTime: this.filterCondition.createDate[0],
        endDateTime: this.filterCondition.createDate[1],
        pageIndex: this.page,
        pageSize: 10,
      };
      GetExcelShopList(params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.PageTotal = res.data.total;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    //门店列表导出
    pullList() {
      if (!this.filterCondition.createDate[0]) {
        this.$Message.error("请选择时间");
        return;
      }
      const msg = this.$Message.loading({
        content: "加载中",
        duration: 0,
      });

      var params = {
        shopId: this.filterCondition.ShopId,
        startDateTime: this.filterCondition.createDate[0],
        endDateTime: this.filterCondition.createDate[1],
        uniqueIdL: getCookie("uniqueId"),
        pageIndex: 1,
        pageSize: 10000,
      };
      ExportExcelShopList(params)
        .then((res) => {
          setTimeout(msg, 17);
          if (res.code == 1) {
            window.open(res.msg);
          }
        })
        .catch((err) => {
          setTimeout(msg, 17);
        });
      // GetExcelShopList(params)
      //   .then(res => {
      //     setTimeout(msg, 17);
      //     if (res.code == 1) {
      //       let _that = this;
      //       if (res.data.list.length == 0) {
      //         this.$Message.error("当前列表为空,导出失败");
      //         return false
      //       }
      //       res.data.list.map(item => {
      //         console.log(item);
      //         if (
      //           _that.filterCondition.createDate[0] &&
      //           _that.filterCondition.createDate[0].length > 0
      //         ) {
      //           item.StatisticalTime =
      //             _that.filterCondition.createDate[0] +
      //             "至" +
      //             _that.filterCondition.createDate[1];
      //         } else {
      //           item.StatisticalTime = "";
      //         }
      //       });
      //       if (res.data && res.data.list.length > 0) {
      //         this.tableData = res.data.list;
      //         this.PageTotal = res.data.total;
      //       }
      //       this.pulltableData = res.data.list;
      //       this.export2Excel();
      //     }
      //   })
      //   .catch(err => {
      //     setTimeout(msg, 17);
      //   });
    },
    pageChange(i) {
      this.page = i;
      this.getList();
    },
    //获取当前前一周的时间
    weekTime() {
      var nowdate = new Date();
      var oneweekdate = new Date(nowdate - 7 * 24 * 3600 * 1000);
      var y = oneweekdate.getFullYear();
      var m = oneweekdate.getMonth() + 1;
      var d = oneweekdate.getDate();
      var afterWeek = `${y}-${m}-${d}`;
      var ny = nowdate.getFullYear();
      var nm = nowdate.getMonth() + 1;
      var nd = nowdate.getDate();
      var newWeekq = `${ny}-${nm}-${nd}`;
      this.filterCondition.createDate = [afterWeek, newWeekq];
      this.getList();
    },
  },
  mounted() {
    this.appMobilePhone = localStorage.getItem("app_mobile");
    setTimeout((res) => {
      this.weekTime();
    });
  },
};
</script>
<style lang="scss">
.m-b10 {
  margin-bottom: 40px;
}
.print_btn {
  height: 28px;
  padding: 0 15px;
  background: #2f318b;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  color: white;
  line-height: 28px;
  margin-left: 20px;
}
</style>
<style lang="scss" scoped src="../scss/index.scss"></style>